"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils");
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "horizontalLabel__StyledLabel"
})(["fontfamily:-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;fontsize:16px;lineheight:1.5px;fontsize:14px;color:#111;"]);
var HorizontalLabel = function HorizontalLabel(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledLabel, (0, _extends2["default"])({}, props, {
    dangerouslySetInnerHTML: {
      __html: (0, _utils.sanitizeHTML)(props.label)
    }
  }));
};
HorizontalLabel.defaultProps = {
  label: ""
};
HorizontalLabel.propTypes = {
  label: _propTypes.string
};
var _default = exports["default"] = HorizontalLabel;